export default __webpack_public_path__ + "4acf2d51717df0c3a7da5c4cff6cf8dc.png";